
import { createSelector } from 'reselect'
import { isEmpty, keys } from 'lodash'

const innerStateSelector = state => state.chat


const groupChatTypersMessageSelector = createSelector(
   innerStateSelector,
   (state) => {
      const typers = state.groupChat.typers
      let message = null;
      if(!isEmpty(typers)) {
         const objectKeys = keys(typers);
         if(objectKeys.length > 1) {
            message = 'Several people are typing...';
         } else {
            message = `${ typers[objectKeys[0]].username || typers[objectKeys[0]].screen_name } is typing...`;
         }
      }
      return message
   }
);
const privateChatTypersMessageSelector = createSelector(
   innerStateSelector,
   (state) => {
      const typers = state.privateChat.typers
      let message = null;
      if(!isEmpty(typers)) {
         const objectKeys = keys(typers);
         if(objectKeys.length > 1) {
            message = 'Several people are typing...';
         } else {
            message = `${ typers[objectKeys[0]].username || typers[objectKeys[0]].screen_name } is typing...`;
         }
      }
      return message
   }
);
const unreadMessageCount = createSelector(
   innerStateSelector,
   (state) => {
      let acc = state.settings.is_group_chat_active ? state.groupChat.unread_messages_count || 0 : 0
      let count = state.settings.chat_private_is_active ? state.privateChat.unread_messages_count + acc : acc
      if(count > 100){
         count = '99+'
      }
      return count
   }
);

const likedMemberByMessageSelector = createSelector(
   innerStateSelector,
   (state) => {
      let { likedMemberByMessage, onlineUsers } = state
      let data = likedMemberByMessage.data
      if(data) {
         data = [...data].map(i => {
            const { ...elm } = i
            elm.is_online = !!onlineUsers.find(user => user.uuid === elm.uuid)
            return elm
         })
      }
      return { ...likedMemberByMessage, data }
   }
);
const privateChatSelector = createSelector(
   innerStateSelector,
   (state) => {
      let { privateChat, onlineUsers } = state
      const adminIsOnline = onlineUsers.find(i => i.uuid === privateChat.user_uuid)
      return { ...privateChat, is_online: adminIsOnline }
   }
);

const showNavigationListSelector = createSelector(
   innerStateSelector,
   (state) => (state.showNavigationList)
);

const isFetchingInitSelector = createSelector(
   innerStateSelector,
   (state) => (state.isFetchingInit)
);
const isFetchingMessageSelector = createSelector(
   innerStateSelector,
   (state) => (state.isFetchingMessage)
);
const isNextFetchingMessageSelector = createSelector(
   innerStateSelector,
   (state) => (state.isNextFetchingMessage)
);
const onlineUsersSelector = createSelector(
   innerStateSelector,
   (state) => (state.onlineUsers)
);
const isSocketConnectedSelector = createSelector(
   innerStateSelector,
   (state) => (state.isSocketConnected)
);
const groupChatSelector = createSelector(
   innerStateSelector,
   (state) => (state.groupChat)
);

const settingsSelector = createSelector(
   innerStateSelector,
   (state) => (state.settings)
);
const privateMessagesSelector = createSelector(
   innerStateSelector,
   (state) => (state.privateMessages)
);
const publicMessagesSelector = createSelector(
   innerStateSelector,
   (state) => (state.publicMessages)
);
const activeMessageTabSelector = createSelector(
   innerStateSelector,
   (state) => (state.activeMessageTab)
);
const mutedInfoSelector = createSelector(
   innerStateSelector,
   (state) => (state.mutedInfo)
);
const chatPanelSelector = createSelector(
   innerStateSelector,
   (state) => (state.chatPanel)
);
const initedSelector = createSelector(
   innerStateSelector,
   (state) => (state.inited)
);
// const hiddeChatIconSelector = createSelector(
//    innerStateSelector,
//    (state) => (state.hiddeChatIcon)
// );
const hiddeChatIconSelector = createSelector(
   innerStateSelector,
   (state) => {
      let { settings } = state
      return settings && !settings.chat_private_is_active && !settings.is_group_chat_active
   }
);

export {
   showNavigationListSelector,
   isFetchingInitSelector,
   isFetchingMessageSelector,
   isNextFetchingMessageSelector,
   likedMemberByMessageSelector,
   onlineUsersSelector,
   isSocketConnectedSelector,
   groupChatSelector,
   privateChatSelector,
   settingsSelector,
   groupChatTypersMessageSelector,

   privateMessagesSelector,
   publicMessagesSelector,
   activeMessageTabSelector,
   unreadMessageCount,
   privateChatTypersMessageSelector,

   mutedInfoSelector,
   chatPanelSelector,
   initedSelector,
   hiddeChatIconSelector,
}
